import "./TheSpace.module.css";
import Header from "@/reusable_sections/Header";
import SpecialistenInElektronica from "./sections/SpecialistenInElektronica";
import ArtisanalPresentation from "./sections/ArtisanalPresentation";
import NuestroEquipo from "./sections/NuestroEquipo";
import Footer from "@/reusable_sections/Footer";
export default function TheSpacePage() {
  return <div>
      <Header />
      <SpecialistenInElektronica />
      <ArtisanalPresentation />
      <NuestroEquipo />
      <Footer />
    </div>;
}